var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex align-items-center mb-4"},[_c('h2',[_vm._v(_vm._s(_vm.$t('perfil.tutor')))]),_c('span',{staticClass:"barra-tit flex-fill"})]),_c('div',{staticClass:"box-meus-tutores"},[_c('meu-tutores',{attrs:{"aluno":_vm.aluno}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }